import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import { Dialog } from "../Dialog/Dialog";
import { DialogContent } from "../Dialog/DialogContent";
import { DialogFooter } from "../Dialog/DialogFooter";
import { Card } from "../../Cards/Card/Card";
import { ButtonBar } from "../../Buttons/ButtonBar/ButtonBar";
import { RightButtons } from "../../Buttons/ButtonBar/RightButtons";
import { Button } from "../../Buttons/Button/Button";

export class ConfirmDialog extends BaseComponent<IConfirmDialogProps, IConfirmDialogState>
{
    public static okButtonLabel = '';
    public static cancelButtonLabel = '';

    constructor(props: IConfirmDialogProps)
    {
        super(props);
        this.state = {
            show: props.show ?? false,
            onClose: () => props.onClose?.() ?? {},
            onConfirm: () => props.onConfirm?.() ?? {},
        };
    }

    public componentDidUpdate(prevProps: IConfirmDialogProps): void
    {
        const props = this.props;
        if (prevProps.show != props.show)
        {
            this.setState({ show: props.show ?? false });
        }
        if (prevProps.onClose != props.onClose)
        {
            this.setState({ onClose: (() => props.onClose?.() ?? {}) });
        }
        if (prevProps.onConfirm != props.onConfirm)
        {
            this.setState({ onConfirm: (() => props.onConfirm?.() ?? {}) });
        }
    }

    public show(): Promise<boolean>
    {
        return new Promise(resolve =>
        {
            this.setState({
                show: true,
                onClose: () =>
                {
                    this.setState({ show: false });
                    resolve(false);
                },
                onConfirm: () =>
                {
                    this.setState({ show: false });
                    resolve(true);
                },
            });
        });
    }

    public render(): JSX.Element
    {

        return (
            <>
                <Dialog
                    isOpen={this.state.show}
                    onOpenChange={() => this.state.onClose()}
                    lg={5}
                >
                    <DialogContent>
                        <Card
                            title={this.props.header}
                        >
                            {this.props.content}
                        </Card>
                    </DialogContent>
                    <DialogFooter>
                        <ButtonBar>
                            <RightButtons>
                                <Button
                                    styleType='outlined'
                                    onClick={() => this.state.onClose()}
                                >
                                    {this.props.cancelButtonLabel ?? ConfirmDialog.cancelButtonLabel}
                                </Button>
                                <Button
                                    styleType='filled'
                                    color={this.props.confirmButtonColor}
                                    rightIcon={this.props.confirmButtonIcon}
                                    onClick={() => this.state.onConfirm()}
                                >
                                    {this.props.okButtonLabel ?? ConfirmDialog.okButtonLabel}
                                </Button>
                            </RightButtons>
                        </ButtonBar>
                    </DialogFooter>
                </Dialog>
            </>
        );
    }
}

export interface IConfirmDialogProps
{
    okButtonLabel?: string;
    cancelButtonLabel?: string;
    show?: boolean;
    header: string;
    content: string;
    onClose?: () => void;
    onConfirm?: () => void;
    confirmButtonColor?: string;
    confirmButtonIcon?: React.ReactElement;
}

export interface IConfirmDialogState
{
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
}
